// extracted by mini-css-extract-plugin
export default {"container":"styles_container__2tucY","select":"styles_select__598UB","label":"styles_label__cu6ag","asterisk":"styles_asterisk__MKnQB","error":"styles_error__-54ms"};